import constants from './constants';

export function openEditContributionDialog() {
    return function(dispatch) {
        dispatch({type: constants.MUTUAL_AID_OPEN_EDIT_BENCHMARK_CONTRIBUTION_DIALOG});
    }
}

export function closeEditContributionDialog() {
    return function(dispatch) {
        dispatch({type: constants.MUTUAL_AID_CLOSE_EDIT_BENCHMARK_CONTRIBUTION_DIALOG});
    }
}

export function setContributionBenchmark(benchmark) {
    return function(dispatch) {
        dispatch({type: constants.MUTUAL_AID_SET_CONTRIBUTION_BENCHMARK, payload: benchmark})
    }
}

export function openThankyouDialog() {
    return function(dispatch) {
        dispatch({type: constants.MUTUAL_AID_OPEN_THANKYOU_DIALOG})
    }
}

export function closeThankyouDialog() {
    return function(dispatch) {
        dispatch({type: constants.MUTUAL_AID_CLOSE_THANKYOU_DIALOG})
    }
}